import { ComponentType, PropsWithChildren } from 'react'

import { useIsPreviewMode } from '../../_hooks/use-is-preview-mode.js'

const WarningText = ({ children }: PropsWithChildren) => (
  <span className="title1-emphasized text-error">Preview warning: {children}</span>
)

const WarningBlock = ({ children }: PropsWithChildren) => (
  <div className="flex size-full flex-col items-center justify-center p-100 text-center">
    <WarningText>{children}</WarningText>
  </div>
)

const onlyInPreviewMode =
  <T extends object>(Component: ComponentType<T>) =>
  (props: T) => {
    const isPreviewMode = useIsPreviewMode()
    if (!isPreviewMode) {
      return null
    }

    return <Component {...props} />
  }

export const PreviewWarningBlock = onlyInPreviewMode(WarningBlock)
export const PreviewWarningInline = onlyInPreviewMode(WarningText)
